/*------------------------------------*\
    #HIGHLIGHT-LOCATION 
\*------------------------------------*/


/*  Highlights the current location in a single page app's navigation

    <li><a href="http://someurl/#stage1" class="js-highlight-location">Stage 1</a></li>
    <li><a href="http://someurl/#stage2" class="js-highlight-location">Stage 2</a></li>
    <li><a href="http://someurl/#stage3" class="js-highlight-location">Stage 3</a></li>
    <li><a href="http://someurl/#stage4" class="js-highlight-location">Stage 4</a></li>


    Once the viewport is over the url referenced location it will add the class
    'is current'.
*/


WW.highlightLocation = function($){
    'use strict';

    const stickyNavbarHeight = 55;

    const getLocations = () => {
        const result = [];
        $('.js-highlight-location').each(function() {
            const href = this.href,
                id = href.substring(href.indexOf('#'), href.length),
                target = $(id);
                if (target.length > 0) {
                const targetLocationTop = target.offset().top,
                targetLocationBottom = targetLocationTop + target.outerHeight();

                result.push({
                    el: this,
                    id,
                    target,
                    targetLocationTop,
                    targetLocationBottom
                });
            }
        });
        return result;
    };

    const isLocationWithinViewport = (location, viewportOffsetTop) => {
        return  ((viewportOffsetTop + stickyNavbarHeight) > location.targetLocationTop) && 
                ((viewportOffsetTop + stickyNavbarHeight) < location.targetLocationBottom);
    };

    const removeHighlightFromLocations = () => {
        locations.forEach(function(location) {
            $(location.el).removeClass('is-current');
        });
    };

    const highlightCurrent = (viewportOffsetTop) => {
        const currLocation = locations.filter((location) => {
            return isLocationWithinViewport(location, viewportOffsetTop);
        })[0];
        removeHighlightFromLocations();
        if (currLocation) {
            $(currLocation.el).addClass('is-current');       
        }
    };

    const efficientResize = WW.debounce(() => {
        window.requestAnimationFrame(() => {
            locations = getLocations();        
        });
    }, 200);

    

    $(window).on('resize', efficientResize);
    
    let locations = getLocations();


    (() => {
        let previousOffset;
        const loop = () => {
            let offsetTop = window.pageYOffset;
            if (offsetTop === previousOffset) {
                requestAnimationFrame(loop);
                return false;
            } else {
                previousOffset = offsetTop;
            }
            highlightCurrent(offsetTop);
            requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
    })();
    
    return this;
};

// .highlightLocation($)
